<template>
    <div class="DesktopView">
        <div class="container-wrap ">
            <div class="TableContent">
                <div class="row d-flex justify-content-end align-items-end ">
                    <div class="col-lg-12 left-box ps-3 pe-3 pb-3" @click="$emit('bringForward')">
                        <h2 class="mt-4 mb-0 text-uppercase">
                          {{ apartmentdetail.block }} / Level {{ apartmentdetail.floor_level }}  
                        </h2>
                    </div>
                    <div class="col-lg-12 justify-content-center align-items-end pb-3 ps-3 pe-3 pt-3 bg-white" >
                        <!-- <img src="../../assets/img/icon1.png" class="wid-20 d-block text-center ms-auto me-auto"> -->
                        <div class="w-100 text-center position-relative">
                            <img  :src="apartmentdetail.plot_image" class="PlotPlan">
                            <div class="Circle"  v-for="(i, index) in apartmentdetail.apartments" :id="'plot_'+i.plot_id" @click="i.show_modal = true" :class="i.status" :key="index">
                                <span>{{ i.flat_no}}</span>

                                <VueFinalModal
                                  :id="index"
                                  @click="BringFront(index)"
                                  @opened="BringFront(index)"
                                  v-model="i.show_modal"
                                  :drag="true"
                                  :esc-to-close="true"
                                  :hide-overlay="true"
                                  :prevent-click="true"
                                  :fit-parent="false"
                                  :click-to-close="false"
                                  :lock-scroll="false"
                                  :content-style="{ width: '100%' }"
                                  :z-index-auto="true"
                                  :z-index="true"
                                  :z-index-base="1000000"
                                  :style="{ top: '23.5%', width: '52%', left: ((30+index)+'%'), zIndex: '100000' }"
                                  :class="i.show_modal ? 'opened' : ''">
                                  <div style="width: 100%" v-if="i.show_modal">
                                    <FloorDetails :viewtype="'apartment'" :id="i.plot_id"
                                      @CloseInnerModal="close"
                                      :fromfavourites="false" />                                      
                                  </div>
                                </VueFinalModal>
                            </div>
                        </div>
                        <div class="d-flex mt-3 ">
                          <div class="">
                                <span class="fs-08 statusbtn available">AVAILABLE</span>
                                <span class="fs-08 statusbtn sold">SOLD</span>
                                <span class="fs-08 statusbtn reserved">RESERVED</span>
                                <span class="fs-08 statusbtn not-released">UNRELEASED</span>
                          </div>
                            <div class="flex-fill"></div>

                            <div class="">
                                <img @click="$emit('CloseModal',apartmentdetail.id)" src="../../assets/img/close1.jpg" class="wid-20 d-block cursor-pointer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="myModal" class="myModal">
        <span @click="ClosePop()" class="close">&times;</span>
        <div class="d-flex justify-content-center align-items-center h-100">
            <img class="modal-content" :src="NewImage" />
        </div>
    </div>
    <div class="MobileView">
        <div class="container-wrap ">
            <div class="TableContent">
                <div class="row d-flex justify-content-end align-items-end ">
                    <div class="col-lg-12 left-box ps-3 pe-3 pb-3">
                         <h2 class="mt-4 mb-0 text-uppercase">
                          {{ apartmentdetail.block }} / Level {{ apartmentdetail.floor_level }}  
                        </h2>
                    </div>
                    <div class="col-lg-12 justify-content-center align-items-end pb-3 ps-3 pe-3 pt-3">
                        <!-- <img src="../../assets/img/icon1.png" class="wid-20 d-block text-center ms-auto me-auto"> -->
                        <div class="w-100 text-center position-relative">
                            <img :src="apartmentdetail.plot_image" class="w-100">
                            <div class="Circle" v-for="(i, index) in apartmentdetail.apartments" :id="'plot_'+i.plot_id" @click="i.show_modal = true" :class="i.status" :key="index">
                                <span>{{ i.flat_no}}</span>
                                <VueFinalModal
                                  :id="index"
                                  @click="BringFront(index)"
                                  v-model="i.show_modal"
                                  :drag="true"
                                  :esc-to-close="true"
                                  :hide-overlay="true"
                                  :prevent-click="true"
                                  :fit-parent="false"
                                  :click-to-close="false"
                                  :lock-scroll="false"
                                  :content-style="{ width: '100%' }"
                                  :z-index-auto="true"
                                  :z-index="true"
                                  :z-index-base="1000000"
                                  :style="{ top: '6%', width: '100%', left: '0%', zIndex: '100000' }"                                  
                                  :class="i.show_modal ? 'opened' : ''">
                                  <div style="width: 100%" v-if="i.show_modal">
                                    <FloorDetails :viewtype="'apartment'" :id="i.plot_id"
                                      @CloseInnerModal="close"
                                      :fromfavourites="false" />                                      
                                  </div>
                                </VueFinalModal>
                            </div>
                        </div>
                        <div class="d-flex mt-3 ">
                          <div class="">
                                <span class="fs-08 statusbtn available">AVAILABLE</span>
                                <span class="fs-08 statusbtn sold">SOLD</span>
                                <span class="fs-08 statusbtn reserved">RESERVED</span>
                                <span class="fs-08 statusbtn not-released">UNRELEASED</span>
                          </div>
                            <div class="flex-fill"></div>
                            <div class="">
                                <img @click="$emit('CloseModal',apartmentdetail.id)" src="../../assets/img/close1.jpg" class="wid-20 d-block cursor-pointer">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch } from "vue";
import { ModalService } from '@/services/spec.service';

import { $vfm, VueFinalModal, ModalsContainer } from "vue-final-modal";
import FloorDetails from '@/components/FloorDetails/FloorDetails.vue';
import { Swiper, SwiperSlide } from 'swiper/vue';

// Import Swiper styles
import 'swiper/css';
import "swiper/css/navigation"
import "swiper/css/thumbs"

// import Swiper core and required modules
import SwiperCore, {
    FreeMode, Navigation, Thumbs,
} from 'swiper';

// install Swiper modules
SwiperCore.use([FreeMode, Navigation, Thumbs]);

export default {
    name: 'PlotDetails',
    components: {
        VueFinalModal,
        FloorDetails,
        Swiper,
        SwiperSlide
    },
    props: {
        id: "",
        block: "",
        fromfavourites: Boolean,
    },
    watch:{
      'id'(){
        this.GetPlotImageDetail(this.id);
      }
    },
    created() {
        this.GetPlotImageDetail(this.id);
        ModalService.receiveModalForward().subscribe((res)=>{
          if(res.text == "true"){
            this.BringBack()
          }
        })
    },
    data(){
        return {
            thumbsSwiper: null,
            apartmentdetail: [],
            CheckCookies: [],
            NewImage: "",
            NewModal:false,
            showInnerModal: false,
            imgArr: [
                ('https://aspect.qtcloud.co.uk/images/floorplan-1.jpg'),
                ('https://aspect.qtcloud.co.uk/images/floorplan-2.jpg'),
            ]
        };
    },
    methods: {
        setThumbsSwiper(swiper) {
            this.thumbsSwiper = swiper;
        },
        // UpdateStar(){
        //     if(this.$cookies.get('favourites') != null){
        //         this.CheckCookies = JSON.parse(this.$cookies.get('favourites'))
        //     }
        // },
        GetPlotImageDetail(id){
            fetch(this.base_url+'GetPlotImage&id='+id+'&block='+this.block)
            .then(response => response.json())
            .then(res => {
                this.apartmentdetail = res.data
            });
        },
        AddToFavourites(id){
            let favoritesId = this.$cookies.get('favourites')
            if(favoritesId == null){
                this.$cookies.set('favourites',JSON.stringify([id]),"0" );
            }else{
                let newFavourite = JSON.parse(favoritesId);
                if(!newFavourite.includes(id)){
                    newFavourite.push(id);
                }
                this.$cookies.set('favourites',JSON.stringify(newFavourite),"0");
                
            }
            this.UpdateStar();
            //this.$cookies.set('favourites',user);
        },
        RemoveFromFavourites(id){
            let favoritesId = JSON.parse(this.$cookies.get('favourites'));
            let i = favoritesId.indexOf(id);
            favoritesId.splice(i,1);
            this.$cookies.set('favourites',JSON.stringify(favoritesId),"0");
            this.UpdateStar();
            this.$emit('UpdateFavourites')
        },
        pop(image){
            this.NewImage = image;
            var modal = document.getElementById("myModal");
            modal.style.display = "block";
        },
        ClosePop(){
            var modal = document.getElementById("myModal");
            modal.style.display = "none";
        },
        close(id){           
          setTimeout(()=>{
            this.apartmentdetail.apartments.forEach((e, i)=>{
              if(e.plot_id == id){
                e.show_modal = false;
              }
            })
          })         
        },
        BringFront(index){
          let list = [];
          list = document.getElementsByClassName('opened');
          for (let item of list) {
              if(item.classList.contains('opened')){
                  if(item.id == index.toString()){
                      item.style.zIndex = 1000004;
                  }else{
                      item.style.zIndex = 1000003;
                  }
              }
          }            
        },
        BringBack(){
          let list = [];
          list = document.getElementsByClassName('opened');
          for (let item of list) {
            if(item.classList.contains('opened')){
              item.style.zIndex = -1;
            }
          }
        }



    },
    emits: ['CloseModal','UpdateFavourites','showInnerModal', 'bringForward']
};
</script>

<style scoped lang="scss">

.w-65{
  width:65%;
}

.cursor-pointer {
  cursor: pointer;
}

.container-wrap {
    background: #fff;
    padding: 0px;
    margin: auto;
}
.fs-08{
    font-size: 0.8rem;
}
.wid-20{
    width:20px !important;
}
.fs-20{
    font-size:30px !important;
    line-height:0;
    color:#381b31
}
.wid-30{
    width:30px !important;
}
.heig-30{
    height:30px !important;
}
.colorblue{
    color:#381b31;
}
.btn-blue{
    display: inline-block;
    padding: 7px 30px;
    font-family: var(--bs-btn-font-family);
    font-size: 0.9rem;
    font-weight: 600;
    line-height: var(--bs-btn-line-height);
    color: #fff;
    text-align: center;
    text-decoration: none;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
    border-radius: 0;
    background-color: #381b31;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

//////////////////////

.statusbtn {
  padding: 9px 5px 5px;
  border-radius: 5px;
  margin-right: 1rem;
}

.swiper {
    width: 100%;
    height: 100%;
}

.swiper-slide {
    text-align: center;
    font-size: 18px;
    background: #fff;
    /* Center slide text vertically */
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.swiper {
    width: 100%;
    height: 300px;
    margin-left: auto;
    margin-right: auto;
    z-index: 0;
}

.swiper-button-prev {
  color: #355063 !important;
}

.swiper-button-next {
  color: #355063 !important;
}

.swiper-button-next::after, .swiper-rtl .swiper-button-prev::after {
  color: red !important;
}

.swiper-slide {
    background-size: cover;
    background-position: center;
}

.mySwiper2 {
    height: 80%;
    width: 100%;

    div {
        background: transparent !important;
    }

    img {
        object-fit: contain !important;
    }
}

.mySwiper {
    height: 20%;
    box-sizing: border-box;
    padding: 10px 0;
}

.mySwiper .swiper-slide {
    width: 25%;
    height: 100%;
    opacity: 0.4;
}

.mySwiper .swiper-slide-thumb-active {
    opacity: 1;
}

.swiper-slide img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
}

//////////////////////////

.ImageViewer {
    cursor:pointer;
}

.btn-sold {
    background: #903737;
    color: #fff;
    text-transform: uppercase;
    width: 100px;
    height: 30px;
    font-size: 18px;
    //font-family: "aeonik-bold" !important;
    border: none;
}

.status-btn{
    color: #fff;
    text-transform: uppercase;
    width: auto;
    font-size: 18px;
    text-align:center;
    display: inline;
    margin-right:1rem;
    //font-family: "aeonik-bold" !important;
}

.available {
    //background:#E0E0D4;
    background:#00ca00
}

.not-released {
    background:#E0E0D4;
}
.reserved {
    background:orange;
}
.sold {
    background:red;
}

.sold-btn {
    background: red;
    color: #fff;
    text-transform: uppercase;
    width: 100px;
    height: 30px;
    font-size: 16px;
    border: none;
}

.TableContent {
    box-shadow: 3px 3px 10px #000;
    border: 2px solid #381b31;
    .row{
      margin:0px; 
    }
    .left-box {
        color:#fff;
        background:#381b31;
        h2 {
            font-size: 2.0rem;
        }

        h4 {
            //font-family: "aeonik-bold";
            font-size: 19px;
            color: #355063
        }

        .table {
            border: none;
            thead,
            tbody,
            tr,
            th {
                border: none;
                padding: 10px 3px;
                color: #fff;
            }
            tr{
                border-bottom: 1px solid #fff;
            }
            th {
                //font-family: "aeonik-bold" !important;
                font-weight: 500;
                font-size: 0.7rem;
            }
            td {
                border: none;
                padding: 3px;
                color: #fff;
                font-size: 0.8rem;
            }
        }
    }

    .right-box {
        img{
            width: 270px;
        }
    }
}

.DarkBlue {
    background: #355063;
    color: #fff;
    padding: 10px 20px;

    div:nth-child(2){
        width: 50px;

    }
    h2 {
        font-size: 20px;
       // font-family: "aeonik-bold";
        margin-bottom: 0;
        display:inline
    }
    .bi-x {
        
        font-size:24px;
    }
}

.DesktopView{
    border: 0px solid #381b31;
}

.MobileView{
    display:none;
    border: 0px solid #381b31;
}

 /* Style the Image Used to Trigger the Modal */
#myImg {
  border-radius: 5px;
  cursor: pointer;
  transition: 0.3s;
}

#myImg:hover {opacity: 0.7;}

/* The Modal (background) */
.myModal {
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  padding-top: 100px; /* Location of the box */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.9); /* Black w/ opacity */
}

/* Modal Content (Image) */
.modal-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add Animation - Zoom in the Modal */
.modal-content, #caption {
  animation-name: zoom;
  animation-duration: 0.6s;
}

@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}

/* The Close Button */
.close {
  position: absolute;
  top: 70px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
  z-index: 9999;
  cursor:pointer
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

.PlotPlan{
  position: relative;
  padding: 30px 0;
  width: 90%;
}

.Circle{
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 30px;
  font-size: 22px;
  cursor: pointer;
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Circle span {
  position: absolute;
  top: 6px;
}

// Block 1 level 1

#plot_1 {
  top: 20%;
  right: 32%;
}

#plot_2 {
  

  top: 20%;
  right: 15%;
}
#plot_3 {
  top: 65%;
  right: 15%;
}
#plot_4 {
  top: 65%;
  right: 32%;
}
#plot_5 {
  top: 65%;
  right: 48%;
}
#plot_6 {
  top: 65%;
  right: 64%;
}
#plot_7 {
  top: 65%;
  right: 84%;
}
#plot_8 {
  top: 20%;
  right: 84%;
}
#plot_9 {
  top: 20%;
  right: 64%;
}

// Block 2 level 1

#plot_10 {
  top: 65%;
  right: 48%;
}

#plot_11 {
  top: 65%;
  right: 64%;
}
#plot_12 {
  top: 65%;
  right: 84%;
}
#plot_13 {
  top: 20%;
  right: 84%;
}
#plot_14 {
  top: 20%;
  right: 64%;
}
#plot_15 {
  top: 20%;
  right: 48%;
}
#plot_16 {
  top: 20%;
  right: 32%;
}
#plot_17 {
  top: 20%;
  right: 15%;
}
#plot_18 {
  top: 65%;
  right: 15%;
}


// Block 1 level 2

#plot_19 {
  top: 20%;
  right: 32%;
}

#plot_20 {
  top: 20%;
  right: 15%;
}
#plot_21 {
  top: 65%;
  right: 15%;
}
#plot_22 {
  top: 65%;
  right: 32%;
}
#plot_23 {
  top: 65%;
  right: 48%;
}
#plot_24 {
  top: 65%;
  right: 64%;
}
#plot_25 {
  top: 65%;
  right: 84%;
}
#plot_26 {
  top: 20%;
  right: 84%;
}
#plot_27 {
  top: 20%;
  right: 64%;
}

// Block 2 level 2

#plot_28 {
  top: 65%;
  right: 48%;
}

#plot_29 {
  top: 65%;
  right: 64%;
}
#plot_30 {
  top: 65%;
  right: 84%;
}
#plot_31 {
  top: 20%;
  right: 84%;
}
#plot_32 {
  top: 20%;
  right: 64%;
}
#plot_33 {
  top: 20%;
  right: 48%;
}
#plot_34 {
  top: 20%;
  right: 32%;
}
#plot_35 {
  top: 20%;
  right: 15%;
}
#plot_36 {
  top: 65%;
  right: 15%;
}

// Block 1 level 3

#plot_37 {
  top: 20%;
  right: 32%;
}

#plot_38 {
  top: 20%;
  right: 15%;
}
#plot_39 {
  top: 65%;
  right: 15%;
}
#plot_40 {
  top: 65%;
  right: 32%;
}
#plot_41 {
  top: 65%;
  right: 48%;
}
#plot_42 {
  top: 65%;
  right: 64%;
}
#plot_43 {
  top: 65%;
  right: 84%;
}
#plot_44 {
  top: 20%;
  right: 84%;
}
#plot_45 {
  top: 20%;
  right: 64%;
}

// Block 2 level 3

#plot_46 {
  top: 65%;
  right: 48%;
}

#plot_47 {
  top: 65%;
  right: 64%;
}
#plot_48 {
  top: 65%;
  right: 84%;
}
#plot_49 {
  top: 20%;
  right: 84%;
}
#plot_50 {
  top: 20%;
  right: 64%;
}
#plot_51 {
  top: 20%;
  right: 48%;
}
#plot_52 {
  top: 20%;
  right: 32%;
}
#plot_53 {
  top: 20%;
  right: 15%;
}
#plot_54 {
  top: 65%;
  right: 15%;
}

// Block 1 level 4

#plot_55 {
  top: 20%;
  right: 32%;
}

#plot_56 {
  top: 20%;
  right: 15%;
}
#plot_57 {
  top: 65%;
  right: 15%;
}
#plot_58 {
  top: 65%;
  right: 32%;
}
#plot_59 {
  top: 65%;
  right: 48%;
}
#plot_60 {
  top: 65%;
  right: 64%;
}
#plot_61 {
  top: 65%;
  right: 84%;
}
#plot_62 {
  top: 20%;
  right: 84%;
}
#plot_63 {
  top: 20%;
  right: 64%;
}

// Block 2 level 4

#plot_64 {
  top: 65%;
  right: 48%;
}

#plot_65 {
  top: 65%;
  right: 64%;
}
#plot_66 {
  top: 65%;
  right: 84%;
}
#plot_67 {
  top: 20%;
  right: 84%;
}
#plot_68 {
  top: 20%;
  right: 64%;
}
#plot_69 {
  top: 20%;
  right: 48%;
}
#plot_70 {
  top: 20%;
  right: 32%;
}
#plot_71 {
  top: 20%;
  right: 15%;
}
#plot_72 {
  top: 65%;
  right: 15%;
}

// Block 1 level 5

#plot_74 {
  top: 20%;
  right: 32%;
}

#plot_75 {
  top: 20%;
  right: 15%;
}
#plot_76 {
  top: 65%;
  right: 15%;
}
#plot_77 {
  top: 65%;
  right: 32%;
}
#plot_78 {
  top: 65%;
  right: 48%;
}
#plot_79 {
  top: 65%;
  right: 64%;
}
#plot_80 {
  top: 65%;
  right: 84%;
}
#plot_81 {
  top: 20%;
  right: 84%;
}
#plot_82 {
  top: 20%;
  right: 64%;
}

// Block 2 level 5

#plot_83 {
  top: 65%;
  right: 48%;
}

#plot_84 {
  top: 65%;
  right: 64%;
}
#plot_85 {
  top: 65%;
  right: 84%;
}
#plot_86 {
  top: 20%;
  right: 84%;
}
#plot_87 {
  top: 20%;
  right: 64%;
}
#plot_88 {
  top: 20%;
  right: 48%;
}
#plot_89 {
  top: 20%;
  right: 32%;
}
#plot_90 {
  top: 20%;
  right: 15%;
}
#plot_91 {
  top: 65%;
  right: 15%;
}

// Block 1 level 6

#plot_92 {
  top: 20%;
  right: 32%;

}

#plot_93 {
  top: 20%;
  right: 15%;
}
#plot_94 {
  top: 65%;
  right: 15%;
}
#plot_95 {
  top: 65%;
  right: 32%;
}
#plot_96 {
  top: 65%;
  right: 48%;
}
#plot_97 {
  
  top: 65%;
  right: 64%;
}
#plot_98 {

  top: 65%;
  right: 84%;
 
}
#plot_99 {

  top: 20%;
  right: 84%;
  
}
#plot_100 {

  top: 20%;
  right: 64%;
 
}

// Block 2 level 6

#plot_101 {
  top: 65%;
  right: 48%;
}

#plot_102 {
  top: 65%;
  right: 64%;
}
#plot_103 {
  top: 65%;
  right: 84%;
}
#plot_104 {
  top: 20%;
  right: 84%;
}
#plot_105 {
  top: 20%;
  right: 64%;
}
#plot_106 {
  top: 20%;
  right: 48%;
}
#plot_107 {
  top: 20%;
  right: 32%;
}
#plot_108 {
  top: 20%;
  right: 15%;
}
#plot_109 {
  top: 65%;
  right: 15%;
}

// Block 1 level 7

#plot_110 {
  top: 20%;
  right: 32%;
}

#plot_111 {
  top: 20%;
  right: 15%;
}
#plot_112 {
  top: 65%;
  right: 15%;
}
#plot_113 {
  top: 65%;
  right: 32%;
}
#plot_114 {
  top: 65%;
  right: 48%;
}
#plot_115 {
  top: 65%;
  right: 64%;
}
#plot_116 {
  top: 65%;
  right: 84%;
}
#plot_117 {
  top: 20%;
  right: 84%;
}
#plot_118 {
  top: 20%;
  right: 64%;
}

// Block 2 level 7

#plot_119 {
  top: 65%;
  right: 48%;
}

#plot_120 {
  top: 65%;
  right: 64%;
}
#plot_121 {
  top: 65%;
  right: 84%;
}
#plot_122 {
  top: 20%;
  right: 84%;
}
#plot_123 {
  top: 20%;
  right: 64%;
}
#plot_124 {
  top: 20%;
  right: 48%;
}
#plot_125 {
  top: 20%;
  right: 32%;
}
#plot_126 {
  top: 20%;
  right: 15%;
}
#plot_127 {
  top: 65%;
  right: 15%;
}

// Block 1 level 8

#plot_128 {
  top: 20%;
  right: 28%;
}

#plot_129 {
  top: 65%;
  right: 28%;
}
#plot_130 {
  top: 65%;
  right: 48%;
}
#plot_131 {
  top: 65%;
  right: 64%;
}
#plot_132 {
  top: 20%;
  right: 64%;
}

// Block 2 level 8

#plot_133 {
  top: 65%;
  right: 48%;
}

#plot_134 {
  top: 65%;
  right: 64%;
}
#plot_135 {
  top: 65%;
  right: 84%;
}
#plot_136 {
  top: 20%;
  right: 84%;
}
#plot_137 {
  top: 20%;
  right: 64%;
}
#plot_138 {
  top: 20%;
  right: 48%;
}
#plot_139 {
  top: 20%;
  right: 32%;
}
#plot_140 {
  top: 20%;
  right: 15%;
}
#plot_141 {
  top: 65%;
  right: 15%;
}

// Block 2 level 9

#plot_142 {
  top: 65%;
  right: 48%;
}

#plot_143 {
  top: 65%;
  right: 64%;
}
#plot_144 {
  top: 65%;
  right: 84%;
}
#plot_145 {
  top: 20%;
  right: 84%;
}
#plot_146 {
  top: 20%;
  right: 64%;
}
#plot_147 {
  top: 20%;
  right: 48%;
}
#plot_148 {
  top: 20%;
  right: 32%;
}
#plot_149 {
  top: 20%;
  right: 15%;
}
#plot_150 {
  top: 65%;
  right: 15%;
}




/* 100% Image Width on Smaller Screens */
@media only screen and (max-width: 700px){
  .modal-content {
    width: 100%;
  }
} 

@media screen and (max-width: 1365px) {
    .MobileView {
        display:Block !important;
    }
    .DesktopView {
        display:none !important;
    }
}

@media screen and (max-width: 800px) {
    .container-wrap {
        .TableContent {
            .row {
                padding: 0 !important
            }
        }
    }
    .statusbtn {
      margin-right: 0.3rem;
    }
    .Circle{
      width: 30px;
      height: 30px;
      border-radius: 25px;
      font-size: 18px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .Circle span {
      position: absolute;
      top: 3px;
    }
    
}
</style>